import { AlertTriangle, CheckSquare, GitPullRequestArrow, Megaphone, Settings2, Target, type LucideIcon } from 'lucide-react';
import type { NotificationCategory, NotificationPriority } from '@nexops/shared';
import type { BadgeTone } from '@/shared/ui';
import type { MessageKey } from '@/i18n/I18nProvider';

export interface CategoryStyle {
  icon: LucideIcon;
  /** Tailwind gradient classes for the icon tile (full literals so Tailwind keeps them). */
  gradient: string;
  /** Accent hex — used for the unread stripe and the hero accents. */
  color: string;
  labelKey: MessageKey;
}

export const CATEGORY_STYLE: Record<NotificationCategory, CategoryStyle> = {
  ALERT: { icon: AlertTriangle, gradient: 'from-amber-500 to-orange-500', color: '#f59e0b', labelKey: 'notifs.category.ALERT' },
  TASK: { icon: CheckSquare, gradient: 'from-teal-500 to-emerald-500', color: '#14b8a6', labelKey: 'notifs.category.TASK' },
  APPROVAL: { icon: GitPullRequestArrow, gradient: 'from-indigo-500 to-violet-500', color: '#6366f1', labelKey: 'notifs.category.APPROVAL' },
  LEAD: { icon: Target, gradient: 'from-violet-500 to-fuchsia-500', color: '#8b5cf6', labelKey: 'notifs.category.LEAD' },
  ANNOUNCEMENT: { icon: Megaphone, gradient: 'from-sky-500 to-blue-600', color: '#0ea5e9', labelKey: 'notifs.category.ANNOUNCEMENT' },
  SYSTEM: { icon: Settings2, gradient: 'from-slate-500 to-slate-600', color: '#64748b', labelKey: 'notifs.category.SYSTEM' },
};

export const PRIORITY_TONE: Record<NotificationPriority, BadgeTone> = { HIGH: 'danger', MEDIUM: 'warning', LOW: 'neutral' };

/** Gradient bar at the top of the "new notification" dialog (per priority). */
export const PRIORITY_BAR: Record<NotificationPriority, string> = {
  HIGH: 'from-rose-500 to-orange-500',
  MEDIUM: 'from-amber-400 to-yellow-400',
  LOW: 'from-sky-400 to-blue-500',
};
